export default {
  methods: {

    set_LocalValues(){

      // DataItems
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))

      // Json
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.table    = json.table
      this.sundries = json.sundries

      
    },

  }
}